import React from 'react';
import { Link } from 'react-router-dom';

import './css/Main.css';

export default function MainHero() {
  return (
    <>
      <section className="hero">
        <div className="hero-left">
          <h1>SELL HIGHER.<br />BUY SMARTER.</h1>

          <p style={{ whiteSpace: "pre-wrap" }}>
            Malaysia's trusted peer-to-peer used car platform. {"\n"}
            Buy directly from owners and sell directly to buyers {"\n"}
            while P2PAUTO handles the complicated process for you.
          </p>

          <div className="hero-buttons">
            <Link to="#process" className="btn btn-primary">SELL MY CAR</Link>
            <Link to="/listing" onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "smooth" })} className="btn btn-secondary">BROWSE CARS</Link>
          </div>
        </div>

        {/*<div className="hero-right">
          <img
            className="hero-img"
            src="hero-img.png"
            alt="Car"
          />
        </div>*/}

      </section>
      <section className="hero-mobile">
        <h1>SELL HIGHER.<br />BUY SMARTER.</h1>
        <p>Malaysia's trusted peer-to-peer used car platform. We help sellers earn more and buyers get greater value through professional inspection and transparent transactions.</p>
        <div className="btns-mobile">
          <Link to="#process" className="btn-mobile btn-primary">SELL MY CAR</Link>
          <Link to="/listing" onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "smooth" })} className="btn-mobile btn-secondary">BUY CARS</Link>
        </div>
      </section>
    </>
  )
}
